import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import type { PreferredRateOnboardingOption } from 'lumen/components/hotel/wizards/preferred-rate-onboarding/preferred-rate-onboarding-options';
import type HotelWizardsPreferredRateOnboardingRoute from 'lumen/routes/hotel/wizards/preferred-rate-onboarding';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelWizardsPreferredRateOnboardingPersonsController extends Controller {
  declare model: ModelFrom<HotelWizardsPreferredRateOnboardingRoute>;

  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service('wizards/preferred-rate-onboarding')
  declare wizardsPreferredRateOnboarding: Services['wizards/preferred-rate-onboarding'];

  @cached
  get personsOptions(): PreferredRateOnboardingOption[] {
    const persons =
      this.model.requestPricingAssistantRatePreferencesOptionsTaskResult.value
        ?.persons ?? [];

    return persons.map((person) => {
      const personString = person.toString();
      return {
        id: personString,
        label: this.intl.t('rates.persons_selection', {
          count: personString,
        }),
        isChecked:
          personString === this.wizardsPreferredRateOnboarding.selectedPersons,
      };
    });
  }

  get selectedPersons(): string {
    return this.wizardsPreferredRateOnboarding.selectedPersons;
  }

  @action onBack(): void {
    this.router.transitionTo(
      'hotel.wizards.preferred-rate-onboarding.room-type',
    );
  }

  @action onContinue(): void {
    this.router.transitionTo(
      'hotel.wizards.preferred-rate-onboarding.meal-type',
    );
  }

  @action onSkip(): void {
    this.router.transitionTo('hotel.pricing-manager');
  }

  @action
  updateSelectedPersons(selectedPersons: PreferredRateOnboardingOption): void {
    this.wizardsPreferredRateOnboarding.updatePersons(selectedPersons.id);
  }
}
